export const LOGOUT_PATH = '/logout';

export function isLogoutPath(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  return path === LOGOUT_PATH;
}
